<template>
  <div class="d-flex justify-space-between">
    <v-chip
      v-if="metadata.confidenceScore"
      size="small"
      :color="
        metadata.confidenceScore === 'high_confidence_in_ocr'
          ? 'success'
          : metadata.confidenceScore === 'medium_confidence_in_ocr'
          ? 'warning'
          : 'error'
      "
      class="ml-2"
      density="comfortable">
      {{
        metadata.confidenceScore === "high_confidence_in_ocr"
          ? "High"
          : metadata.confidenceScore === "medium_confidence_in_ocr"
          ? "Medium"
          : "Low"
      }}
    </v-chip>
    <div>
      <v-btn
        v-if="metadata.boundingBox"
        variant="text"
        size="small"
        class="text-caption"
        @click="onHighlightBoundingBox">
        Show
      </v-btn>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  metadata: {
    type: Object,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(["highlightBoundingBox"]);

const onHighlightBoundingBox = () => {
  emit("highlightBoundingBox", {
    pageNumber: props.metadata.pageNumber + 1,
    boundingBox: props.metadata.boundingBox,
    fieldKey: props.label,
  });
};
</script>

<style scoped></style>
